const elements = {
  body: document.body,
  toggles: document.body.querySelectorAll('.js-search-toggle, .js-search-toggle--desktop'),
  searchbar: document.querySelector('.js-searchbar'),
  currentPageLink: document.querySelector('.js-meganav [aria-current]'),
};

const mediaQuery = window.matchMedia('(min-width: 61.25em)');

const openSearchBtn = document.querySelector('.js-search-toggle');
const openSearchBtnDesktop = document.querySelector('.js-search-toggle--desktop');
const closeSearchBtn = elements.searchbar.querySelector('.js-search-close');
const searchInput = elements.searchbar.querySelector('.js-searchbar-input');

const classes = {
  active: 'is-active',
  searchOverlay: 'is-search',
};

let activeSearch = false;

function handleEscape(e) {
  if (e.key === 'Escape') {
    e.preventDefault();
    closeSearch();
  }
}

function closeSearch() {
  activeSearch = false;
  openSearchBtn.setAttribute('aria-expanded', activeSearch);
  openSearchBtnDesktop.setAttribute('aria-expanded', activeSearch);
  closeSearchBtn.setAttribute('aria-expanded', activeSearch);
  elements.searchbar.setAttribute('hidden', '');

  elements.searchbar.classList.remove(classes.active);
  elements.body.classList.remove(classes.searchOverlay);

  document.body.removeEventListener('click', clickOutsideSearch);
  elements.searchbar.removeEventListener('focusout', handleFocus);
  closeSearchBtn.removeEventListener('click', closeSearch);
  // stop listening for escape keydown
  window.removeEventListener('keydown', handleEscape);

  if (mediaQuery) {
    openSearchBtnDesktop.focus();
  }
}

function openSearch() {
  activeSearch = true;
  openSearchBtn.setAttribute('aria-expanded', activeSearch);
  openSearchBtnDesktop.setAttribute('aria-expanded', activeSearch);
  closeSearchBtn.setAttribute('aria-expanded', activeSearch);
  elements.searchbar.removeAttribute('hidden');
  elements.searchbar.classList.add(classes.active);
  document.body.classList.add(classes.searchOverlay);

  closeSearchBtn.addEventListener('click', closeSearch);
  elements.searchbar.addEventListener('focusout', handleFocus);
  window.addEventListener('keydown', handleEscape);

  setTimeout(function () {
    searchInput.focus();
    // clickOutside add needs a delay for voiceOver in Safari
    document.body.addEventListener('click', clickOutsideSearch);
  }, 500);
}

function toggleVisibility() {
  if (activeSearch === true) {
    closeSearch();
  } else {
    openSearch();
  }
}

function handleFocus(event) {
  // return early if tabbing with keyboard or focus source is an open button
  if (
    !elements.body.classList.contains('is-tabbing') ||
    event.relatedTarget === openSearchBtn ||
    event.relatedTarget === openSearchBtnDesktop
  ) {
    return;
  }

  if (!elements.searchbar.contains(event.relatedTarget) && document.activeElement !== this) {
    closeSearch();
  }
}

function clickOutsideSearch(e) {
  if (
    e.target !== openSearchBtn &&
    e.target !== openSearchBtnDesktop &&
    !e.target.closest('.js-searchbar')
  ) {
    closeSearch();
  }
}

function init() {
  if (elements.toggles.length) {
    elements.toggles.forEach((el) => {
      el.addEventListener('click', toggleVisibility);
      el.removeAttribute('hidden');
    });
    mediaQuery.addEventListener('change', closeSearch.bind(this, true));
  }
}

export default init;
